import {
    ArrowDownward as ArrowDownwardIcon,
    ArrowUpward as ArrowUpwardIcon,
    ListAlt as ListAltIcon,
    Store as StoreIcon,
    PersonOutline as PersonOutlineIcon,
    QrCode,
} from '@mui/icons-material';
import {
    BTC,
    BulkPayIcon,
    DepositIcon,
    ETH,
    FXIcon,
    MerchantIcon,
    ReceiveIcon,
    SendIcon,
    TTPIcon,
    WithdrawalIcon,
    LTC,
    USDT,
    USDC,
    TRX,
    DAI,
} from '../utils/Images';
import { SellCryptoTransaction } from '../components/TransactionForm/SellCryptoTransaction/SellCryptoTransaction';
import ReceiveCryptoForm from '../components/TransactionForm/Receive/ReceiveCryptoForm';
import ExchangeCryptoTransaction from '../components/TransactionForm/ExchangeCrypto/ExchangeCryptoTransaction';
import SendCrypto from '../components/TransactionForm/Send/SendCrypto';
import { BuyCryptoTransaction } from '../components/TransactionForm/BuyCrypto/BuyCryptoTransaction';
import PayOut from '../components/TransactionForm/PayOut/PayOut';
import { getCurrencySymbol } from '../../client/Juno/helpers';
import FxTransaction from '../components/TransactionForm/Fx/FxTransaction';
import TransferTransaction from '../components/TransactionForm/Transfer/TransferTransaction';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import Deposit from '../components/TransactionForm/Deposit';
import MerchantTransferModal from '../components/TransactionForm/Transfer/MerchantTransferModal';
import ReceiveCryptoModal from '../components/TransactionForm/Receive/ReceiveCryptoModal';
import PersonalInfo from '../components/profile/PersonalInfo';
import AccountConfirmation from '../components/profile/AccountConfirmation';
import EmailNotification from '../components/profile/EmailNotification';
import AdditionalAccounts from '../components/profile/AdditionalAccounts';
import SecuritySettings from '../components/profile/securitySettings/SecuritySettings';
import ProfileImage from '../components/profile/ProfileImage';

export const currencyColors = [
    // Cryptocurrencies
    { symbol: 'BTC', color: '#F7931A' },
    { symbol: 'ETH', color: '#627EEA' },
    { symbol: 'DAI', color: '#F5AC37' },
    { symbol: 'USDT', color: '#26A17B' },
    { symbol: 'LTC', color: '#345D9D' },
    { symbol: 'TRX', color: '#FF0013' },
    { symbol: 'XRP', color: '#F1B90B' },
    { symbol: 'USDC', color: '#2775CA' },

    // Fiat currencies
    { symbol: 'USD', color: '#3B82F6' },
    { symbol: 'GBP', color: '#EF4444' },
    { symbol: 'EUR', color: '#2563EB' },
    { symbol: 'AUD', color: '#8B5CF6' },
    { symbol: 'CHF', color: '#DC2626' },
    { symbol: 'CAD', color: '#F97316' },
    { symbol: 'TRY', color: '#D97706' },
    { symbol: 'SGD', color: '#E11D48' },
    { symbol: 'CNY', color: '#F59E0B' },
    { symbol: 'AED', color: '#4ADE80' },
    { symbol: 'MXN', color: '#10B981' },
    { symbol: 'HKD', color: '#EC4899' },
    { symbol: 'JPY', color: '#7C3AED' },
    { symbol: 'THB', color: '#1E40AF' },
    { symbol: 'ILS', color: '#06B6D4' },
    { symbol: 'PLN', color: '#F63B3B' },
];

// for dashboard FiatCryptoTransactionPanel modal
export const transactionTabs = [
    {
        key: 'buy',
        label: 'BUY',
        type: 'crypto',
        content: (
            <div>
                <BuyCryptoTransaction />
            </div>
        ),
    },
    {
        key: 'sell',
        label: 'SELL',
        type: 'crypto',
        content: (
            <div>
                <SellCryptoTransaction />
            </div>
        ),
    },
    {
        key: 'receive',
        label: 'RECEIVE',
        type: 'crypto',
        content: <ReceiveCryptoForm />,
    },
    {
        key: 'exchange',
        label: 'EXCHANGE',
        type: 'crypto',
        content: <ExchangeCryptoTransaction />,
    },
    { key: 'send', label: 'SEND', type: 'crypto', content: <SendCrypto /> },
    {
        key: 'transfer',
        label: 'TRANSFER',
        type: 'fiat',
        content: <TransferTransaction />,
    },
    {
        key: 'withdrawal',
        label: 'WITHDRAWAL',
        type: 'fiat',
        content: <PayOut />,
    },
    { key: 'fx', label: 'FX', type: 'fiat', content: <FxTransaction /> },
];
export const fiatMenuOptions = [
    { key: 'deposit', label: 'Deposit', type: 'fiat' },
    { key: 'paymentOut', label: 'Payment Out', type: 'fiat' },
    { key: 'merchant', label: 'Merchant', type: 'fiat' },
    { key: 'bulkPay', label: 'Bulk Pay', type: 'fiat' },
];

export const fiatTransactions = [
    {
        id: 1,
        key: 'deposit',
        label: 'deposit',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${DepositIcon}`}
                alt="Deposit Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Deposit',
    },
    {
        id: 2,
        key: 'withdraw',
        type: 'withdrawal',
        label: 'withdraw',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${WithdrawalIcon}`}
                alt="Withdrawal Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Withdrawal',
    },
    {
        id: 3,
        key: 'paymentOut',
        label: 'payment out',
        mobileLabel: `TPP's`,
        icon: (
            <img
                src={`https://dev.junomoney.org/images${TTPIcon}`}
                alt="TTP Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Third-party Payment',
    },
    {
        id: 4,
        key: 'transfer',
        label: 'transfer',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${SendIcon}`}
                alt="Transfer Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Transfer',
    },
    {
        id: 5,
        key: 'fx',
        label: 'fx',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${FXIcon}`}
                alt="FX Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'FX',
    },
    {
        id: 6,
        key: 'merchantTransfer',
        label: 'merchant',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${MerchantIcon}`}
                alt="Merchant Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Merchant Transfer',
    },
    {
        id: 7,
        type: 'Bulk Payment',
        key: 'bulkPay',
        label: 'bulkPay',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${BulkPayIcon}`}
                alt="BulkPay Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'BulkPay',
    },
];

export const cryptoTransactions = [
    {
        id: 1,
        key: 'buy',
        label: 'buy',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${DepositIcon}`}
                alt="Buy Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Buy',
    },
    {
        id: 2,
        key: 'sell',
        label: 'sell',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${WithdrawalIcon}`}
                alt="Sell Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Sell',
    },
    {
        id: 3,
        key: 'receive',
        label: 'receive',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${ReceiveIcon}`}
                alt="Receive Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Receive',
    },
    {
        id: 4,
        key: 'exchange',
        label: 'exchange',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${FXIcon}`}
                alt="Exchange Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Exchange',
    },
    {
        id: 5,
        key: 'send',
        label: 'send',
        icon: (
            <img
                src={`https://dev.junomoney.org/images${SendIcon}`}
                alt="Send Icon"
                className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
            />
        ),
        tooltip: 'Send',
    },
];

export const truncateMiddle = (str, frontLen = 6, backLen = 3, truncateStr = '...') => {
    if (!str) return '';
    if (str.length <= frontLen + backLen) return str;
    return `${str.slice(0, frontLen)}${truncateStr}${str.slice(-backLen)}`;
};

export const getIcon = cryptoId => {
    cryptoId = cryptoId?.toUpperCase();
    if (cryptoId === 'BTC') return BTC;
    if (cryptoId === 'ETH') return ETH;
    if (cryptoId === 'LTC') return LTC;
    if (cryptoId === 'USDT') return USDT;
    if (cryptoId === 'USDC') return USDC;
    if (cryptoId === 'TRX') return TRX;
    if (cryptoId === 'DAI') return DAI;
};
export const statusStyle = {
    ERROR: 'bg-[#B62B2B29] text-[#5F0000] dark:bg-[#F970661F] dark:text-[#F97066]',
    SUCCESS: 'bg-[#82B36029] text-[#275F00] dark:bg-[#3CCB7F1F] dark:text-[#3CCB7F]',
    PENDING: 'bg-[#AAAABB29] text-[#26272B] dark:bg-[#D1D1D61F] dark:text-[#D1D1D6]',
    PROCESSING: 'bg-[#AAAABB29] text-[#26272B] dark:bg-[#D1D1D61F] dark:text-[#D1D1D6]',
    REJECTED: 'bg-[#B68C2B29] text-[#5F3E00] dark:bg-[#FDB0221F] dark:text-[#FDB022]',
};

export const cryptoCurrencies = [
    {
        text: 'USDT',
        img: `/common/usdt.png`,
    },
    {
        text: 'DAI',
        img: `/common/crytoicons/dai.png`,
    },
    {
        text: 'USDC',
        img: `/common/crytoicons/usd.png`,
    },
    {
        text: 'ETH',
        img: `/common/crytoicons/eth1.png`,
    },
    {
        text: 'LTC',
        img: `/caas-admin-ui/itc.png`,
    },
    {
        text: 'XRP',
        img: `/common/crytoicons/xrp.png`,
    },
    {
        text: 'BTC',
        img: `/common/crytoicons/btc.png`,
    },
    {
        text: 'TRX',
        img: `/common/crytoicons/trx.png`,
    },
];

export const cryptoCurrencyList = [
    {
        currencyIcon: '/common/usdt.png',
        currencyShortName: 'USDT',
        currencyFullName: 'Ethereum',
    },
    {
        currencyIcon: '/common/crytoicons/dai.png',
        currencyShortName: 'DAI',
        currencyFullName: 'Ethereum',
    },
    {
        currencyIcon: '/common/crytoicons/usd.png',
        currencyShortName: 'USDC',
        currencyFullName: 'Ethereum',
    },
    {
        currencyIcon: '/common/crytoicons/eth1.png',
        currencyShortName: 'ETH',
        currencyFullName: 'Ethereum',
    },
    {
        currencyIcon: '/caas-admin-ui/itc.png',
        currencyShortName: 'LTC',
        currencyFullName: 'Litecoin',
    },
    {
        currencyIcon: '/common/crytoicons/xrp.png',
        currencyShortName: 'XRP',
        currencyFullName: 'Ripple',
    },
    {
        currencyIcon: '/common/crytoicons/btc.png',
        currencyShortName: 'BTC',
        currencyFullName: 'Bitcoin',
    },
    {
        currencyIcon: '/caas-admin-ui/trx.png',
        currencyShortName: 'TRX',
        currencyFullName: 'Tron',
    },
];

export const fiatCurrencyList = [
    {
        currencyIcon: '/cryptonpay/crytoicons/euro.png',
        currencyShortName: 'EUR',
        currencyFullName: 'Euro',
    },
    {
        currencyIcon: '/cryptonpay/crytoicons/usa.png',
        currencyShortName: 'USD',
        currencyFullName: 'US Dollar',
    },
    {
        currencyIcon: '/cryptonpay/crytoicons/uk.png',
        currencyShortName: 'GBP',
        currencyFullName: 'British Pound',
    },
    {
        currencyIcon: '/common/crytoicons/aud.png',
        currencyShortName: 'AUD',
        currencyFullName: 'Australian dollar',
    },
    {
        currencyIcon: '/common/crytoicons/cad.png',
        currencyShortName: 'CAD',
        currencyFullName: 'Canadian dollar',
    },
    {
        currencyIcon: '/common/crytoicons/aed.png',
        currencyShortName: 'AED',
        currencyFullName: 'dirham',
    },
    {
        currencyIcon: '/common/crytoicons/chf.png',
        currencyShortName: 'CHF',
        currencyFullName: 'Swiss franc',
    },
    {
        currencyIcon: '/common/crytoicons/try.png',
        currencyShortName: 'TRY',
        currencyFullName: 'Turkish lira',
    },
    {
        currencyIcon: '/common/crytoicons/hkd.png',
        currencyShortName: 'HKD',
        currencyFullName: 'Hong Kong Dollar',
    },
    {
        currencyIcon: '/common/crytoicons/sgd.png',
        currencyShortName: 'SGD',
        currencyFullName: 'Singapore dollar',
    },
    {
        currencyIcon: '/common/crytoicons/jpy.png',
        currencyShortName: 'JPY',
        currencyFullName: 'Japanese Yen',
    },
    {
        currencyIcon: '/common/crytoicons/cny.png',
        currencyShortName: 'CNY',
        currencyFullName: 'Chinese Yuan',
    },
    {
        currencyIcon: '/common/crytoicons/mxn.png',
        currencyShortName: 'MXN',
        currencyFullName: 'Mexican Peso',
    },
    {
        currencyIcon: '/common/crytoicons/thb.png',
        currencyShortName: 'THB',
        currencyFullName: 'Thai Baht',
    },
    {
        currencyIcon: '/common/crytoicons/ils.png',
        currencyShortName: 'ILS',
        currencyFullName: 'Israeli Shekel',
    },
    {
        currencyIcon: '/common/crytoicons/pln.png',
        currencyShortName: 'PLN',
        currencyFullName: 'Polish złoty',
    },
];

export const IGNORE_HEADER_PATHS = [
    '/client/transactions',
    '/client/balances',
    '/client/accounts',
    '/client/statements',
    '/client/profile',
    '/client/address',
    '/client/bulk-payment',
];

export const statusOptions = ['Success', 'Pending', 'Processing', 'Rejected', 'Error'];

export const getResponsiveWidth = windowWidth => {
    return { width: windowWidth <= 767 ? '100%' : '75%' };
};

export const ErrorTransactions = [
    'PrivateClient:Rejected',
    'PrivateClient:ErrorEncountered',
    'BuyFlow:ErrorEncountered',
    'SellFlow:ErrorEncountered',
    'SendFlow:ErrorEncountered',
    'ReceiveFlow:ErrorEncountered',
    'ExchangeFlow:ErrorEncountered',
];

export const MODAL_COMPONENTS = {
    deposit: Deposit,
    withdraw: PayOut,
    paymentOut: PayOut,
    fx: FxTransaction,
    transfer: TransferTransaction,
    merchantTransfer: MerchantTransferModal,
    buy: BuyCryptoTransaction,
    sell: SellCryptoTransaction,
    receive: ReceiveCryptoModal,
    send: SendCrypto,
    exchange: ExchangeCryptoTransaction,
};

export const filterFiatCurrency = (balancesCurrencies = []) =>
    balancesCurrencies
        .filter(({ balanceAmount = 0, isFreeze = true }) => balanceAmount > 0 && !isFreeze)
        .map(item => ({
            ...item,
            currencySymbol: getCurrencySymbol(item.currencyShortName),
            balanceAmount: Number(item.balanceAmount).toFixed(2),
        }));

export const preciseRound = (num, precision) => {
    if (num === undefined || num === null) return 0;
    const factor = Math.pow(10, precision);
    return Math.round(num * factor) / factor;
};

export const isEmptyObject = obj =>
    obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const DECIMAL_PLACES = {
    FIAT: 2,
    FX_RATE: 6,
    CRYPTO: 8,
    CRYPTO_THRESHOLD: 0.01,
};

export const defaultCurrenciesToDisplay = ['USD', 'EUR', 'GBP', 'BTC', 'ETH', 'LTC'];

// List of required fields
export const REQUIRED_FIELDS = ['beneficiaryName', 'beneficiaryCountry', 'bankCountry'];

// Profile page menu-list
export const ACC_SETTINGS_MENU = [
    { id: 'personalInfo', label: 'Personal Information', component: <PersonalInfo /> },
    // TODO: implement profile image
    { id: 'profileImage', label: 'Profile Image', component: <ProfileImage /> },
    { id: 'securitySettings', label: 'Security Settings', component: <SecuritySettings /> },
    { id: 'emailNotifications', label: 'Email Notifications', component: <EmailNotification /> },
    { id: 'additionalAccounts', label: 'Additional Accounts', component: <AdditionalAccounts /> },
    {
        id: 'accountConfirmation',
        label: 'Account Confirmation',
        component: <AccountConfirmation />,
    },
];

export const fiatFooterItems = [
    {
        id: 1,
        title: 'Home',
        path: '/client',
        icon: (
            <svg
                data-e2e="home-tab"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="stroke-[#344054] dark:stroke-white">
                <path
                    d="M4 11.4522V16.8002C4 17.9203 4 18.4807 4.21799 18.9086C4.40973 19.2849 4.71547 19.5906 5.0918 19.7823C5.5192 20.0001 6.07899 20.0001 7.19691 20.0001H16.8031C17.921 20.0001 18.48 20.0001 18.9074 19.7823C19.2837 19.5906 19.5905 19.2849 19.7822 18.9086C20 18.4811 20 17.9216 20 16.8037V11.4522C20 10.9179 19.9995 10.6506 19.9346 10.4019C19.877 10.1816 19.7825 9.97307 19.6546 9.78464C19.5102 9.57201 19.3096 9.39569 18.9074 9.04383L14.1074 4.84383C13.3608 4.19054 12.9875 3.86406 12.5674 3.73982C12.1972 3.63035 11.8026 3.63035 11.4324 3.73982C11.0126 3.86397 10.6398 4.19014 9.89436 4.84244L5.09277 9.04383C4.69064 9.39569 4.49004 9.57201 4.3457 9.78464C4.21779 9.97307 4.12255 10.1816 4.06497 10.4019C4 10.6506 4 10.9179 4 11.4522Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        id: 2,
        title: 'Balances',
        path: '/client/balances',
        icon: (
            <svg
                data-e2e="balances-tab"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                className="stroke-[#344054] dark:stroke-white">
                <path
                    d="M17 18H3C2.46957 18 1.96086 17.7893 1.58579 17.4142C1.21071 17.0391 1 16.5304 1 16V7C1 6.46957 1.21071 5.96086 1.58579 5.58579C1.96086 5.21071 2.46957 5 3 5H17C17.5304 5 18.0391 5.21071 18.4142 5.58579C18.7893 5.96086 19 6.46957 19 7V16C19 16.5304 18.7893 17.0391 18.4142 17.4142C18.0391 17.7893 17.5304 18 17 18Z"
                    strokeWidth="2"
                />
                <path
                    d="M14.5 12C14.3674 12 14.2402 11.9473 14.1464 11.8536C14.0527 11.7598 14 11.6326 14 11.5C14 11.3674 14.0527 11.2402 14.1464 11.1464C14.2402 11.0527 14.3674 11 14.5 11C14.6326 11 14.7598 11.0527 14.8536 11.1464C14.9473 11.2402 15 11.3674 15 11.5C15 11.6326 14.9473 11.7598 14.8536 11.8536C14.7598 11.9473 14.6326 12 14.5 12Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4.99996V3.60296C15.9999 3.29646 15.9294 2.99408 15.7939 2.71918C15.6583 2.44427 15.4614 2.20419 15.2184 2.01747C14.9753 1.83075 14.6926 1.7024 14.3921 1.64232C14.0915 1.58224 13.7812 1.59204 13.485 1.67096L2.485 4.60396C2.05905 4.71747 1.68254 4.96852 1.41399 5.31809C1.14544 5.66765 0.999902 6.09615 1 6.53696V6.99996"
                    strokeWidth="2"
                />
            </svg>
        ),
    },
    {
        id: 3,
        title: 'Accounts',
        path: '/client/accounts',
        icon: (
            <svg
                data-e2e="accounts-tab"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="text-[#344054] dark:text-white">
                <path d="M6.5 10H4.5V17H6.5V10ZM12.5 10H10.5V17H12.5V10ZM21 19H2V21H21V19ZM18.5 10H16.5V17H18.5V10ZM11.5 3.26L16.71 6H6.29L11.5 3.26ZM11.5 1L2 6V8H21V6L11.5 1Z" />
            </svg>
        ),
    },
    {
        id: 4,
        title: 'Transaction history',
        path: '/client/transactions',
        icon: (
            <svg
                data-e2e="transacrion-history-tab"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="stroke-[#344054] dark:stroke-white">
                <path
                    d="M4.266 16.06C5.11205 17.7705 6.4842 19.1647 8.181 20.038C9.86564 20.903 11.7864 21.1951 13.652 20.87C15.5234 20.541 17.2379 19.6148 18.539 18.23C19.8521 16.8321 20.6882 15.0539 20.927 13.151C21.1696 11.2437 20.8043 9.30851 19.883 7.62098C18.9703 5.9463 17.544 4.60898 15.814 3.80598C14.0957 3.01014 12.1646 2.79667 10.314 3.19798C8.464 3.59898 6.948 4.51098 5.694 5.95298C5.543 6.11298 4.959 6.75898 4.474 7.73398M7.5 7.99998L3.891 8.71998L3 4.99998M12 8.99998V13L15 15"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    // {
    //     id: 5,
    //     title: "Profile",
    //     path: "/client/profile",
    //     icon: <svg
    //         data-e2e="profile-tab"
    //         xmlns="http://www.w3.org/2000/svg"
    //         width="24"
    //         height="24"
    //         viewBox="0 0 24 24"
    //         fill="none"
    //     >
    //         <path
    //             className="fill"
    //             d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10C8 8.93913 8.42143 7.92172 9.17157 7.17157C9.92172 6.42143 10.9391 6 12 6C13.0609 6 14.0783 6.42143 14.8284 7.17157C15.5786 7.92172 16 8.93913 16 10Z"
    //             fill="#344054"
    //         />
    //         <path
    //             className="fill"
    //             fillRule="evenodd"
    //             clipRule="evenodd"
    //             d="M11.592 21.992C6.2585 21.778 2 17.386 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C11.9543 22.0003 11.9087 22.0003 11.863 22C11.7725 22 11.682 21.997 11.592 21.992ZM5.583 18.31C5.50823 18.0953 5.48278 17.8665 5.50854 17.6406C5.5343 17.4147 5.6106 17.1975 5.73179 17.0051C5.85298 16.8128 6.01593 16.6502 6.20856 16.5294C6.40119 16.4086 6.61855 16.3328 6.8445 16.3075C10.7425 15.876 13.2815 15.915 17.1605 16.3165C17.3868 16.3401 17.6046 16.4149 17.7976 16.5354C17.9905 16.6559 18.1534 16.8189 18.2739 17.0119C18.3943 17.2048 18.4691 17.4227 18.4927 17.649C18.5162 17.8753 18.4877 18.1039 18.4095 18.3175C20.072 16.6354 21.003 14.365 21 12C21 7.0295 16.9705 3 12 3C7.0295 3 3 7.0295 3 12C3 14.458 3.9855 16.686 5.583 18.31Z"
    //             fill="#344054"
    //         />
    //     </svg>

    // },
];

export const cryptoFooterItems = [
    {
        id: 1,
        title: 'Home',
        path: '/client',
        icon: (
            <svg
                data-e2e="home-tab"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="stroke-[#344054] dark:stroke-white">
                <path
                    d="M4 11.4522V16.8002C4 17.9203 4 18.4807 4.21799 18.9086C4.40973 19.2849 4.71547 19.5906 5.0918 19.7823C5.5192 20.0001 6.07899 20.0001 7.19691 20.0001H16.8031C17.921 20.0001 18.48 20.0001 18.9074 19.7823C19.2837 19.5906 19.5905 19.2849 19.7822 18.9086C20 18.4811 20 17.9216 20 16.8037V11.4522C20 10.9179 19.9995 10.6506 19.9346 10.4019C19.877 10.1816 19.7825 9.97307 19.6546 9.78464C19.5102 9.57201 19.3096 9.39569 18.9074 9.04383L14.1074 4.84383C13.3608 4.19054 12.9875 3.86406 12.5674 3.73982C12.1972 3.63035 11.8026 3.63035 11.4324 3.73982C11.0126 3.86397 10.6398 4.19014 9.89436 4.84244L5.09277 9.04383C4.69064 9.39569 4.49004 9.57201 4.3457 9.78464C4.21779 9.97307 4.12255 10.1816 4.06497 10.4019C4 10.6506 4 10.9179 4 11.4522Z"
                    // stroke="#344054"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        id: 2,
        title: 'Transaction history',
        path: '/client/transactions',
        icon: (
            <svg
                data-e2e="transacrion-history-tab"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="stroke-[#344054] dark:stroke-white">
                <path
                    d="M4.266 16.06C5.11205 17.7705 6.4842 19.1647 8.181 20.038C9.86564 20.903 11.7864 21.1951 13.652 20.87C15.5234 20.541 17.2379 19.6148 18.539 18.23C19.8521 16.8321 20.6882 15.0539 20.927 13.151C21.1696 11.2437 20.8043 9.30851 19.883 7.62098C18.9703 5.9463 17.544 4.60898 15.814 3.80598C14.0957 3.01014 12.1646 2.79667 10.314 3.19798C8.464 3.59898 6.948 4.51098 5.694 5.95298C5.543 6.11298 4.959 6.75898 4.474 7.73398M7.5 7.99998L3.891 8.71998L3 4.99998M12 8.99998V13L15 15"
                    // stroke="#344054"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        id: 3,
        title: 'Address',
        path: '/client/address',
        icon: (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="text-[#344054] dark:text-white">
                <path d="M9.69236 11.9002L9.69212 11.9002L8.99979 12.6971H8.89979V12.6973C8.89979 12.6974 8.89979 12.6974 8.89979 12.6974L8.89979 13.1608C8.89979 13.6769 9.25483 14.1105 9.80602 14.4097C10.3589 14.7097 11.1263 14.8859 11.9998 14.8859C12.8732 14.8859 13.6407 14.7097 14.1936 14.4096C14.7448 14.1103 15.0998 13.6765 15.0998 13.1599L15.0998 12.6974L14.9998 12.6971H15.0998V12.6972C15.1001 12.5929 15.0799 12.4895 15.0404 12.393C15.0007 12.2964 14.9425 12.2086 14.8689 12.1346C14.7953 12.0605 14.7078 12.0017 14.6115 11.9615C14.5152 11.9213 14.4119 11.9005 14.3075 11.9002H14.3072H9.69236ZM13.2837 10.7101C13.6238 10.3694 13.8146 9.90752 13.8141 9.42611C13.8136 8.9447 13.6219 8.48321 13.2812 8.14314C12.9404 7.80308 12.4785 7.6123 11.9971 7.61278C11.5157 7.61326 11.0542 7.80496 10.7142 8.14571C10.5458 8.31443 10.4123 8.51466 10.3213 8.73497C10.2303 8.95529 10.1836 9.19137 10.1838 9.42974C10.1843 9.91114 10.376 10.3726 10.7167 10.7127C11.0575 11.0528 11.5193 11.2435 12.0007 11.2431C12.4822 11.2426 12.9437 11.0509 13.2837 10.7101ZM6.64265 2.04307C5.87731 2.04307 5.14332 2.3471 4.60214 2.88827C4.06096 3.42945 3.75693 4.16344 3.75693 4.92878V19.0716C3.75693 19.837 4.06096 20.571 4.60214 21.1121C5.14332 21.6533 5.87731 21.9574 6.64265 21.9574H19.4998C19.6968 21.9574 19.8858 21.8791 20.0251 21.7398C20.1644 21.6005 20.2426 21.4115 20.2426 21.2145C20.2426 21.0175 20.1644 20.8285 20.0251 20.6892C19.8858 20.5499 19.6968 20.4716 19.4998 20.4716H6.64265C6.30601 20.4716 5.98064 20.3503 5.72616 20.1299C5.50109 19.935 5.34481 19.6741 5.27842 19.3859H19.4998C19.6968 19.3859 19.8858 19.3077 20.0251 19.1683C20.1644 19.029 20.2426 18.8401 20.2426 18.6431V4.92878C20.2426 4.16344 19.9386 3.42945 19.3974 2.88827C18.8563 2.3471 18.1223 2.04307 17.3569 2.04307H6.64265ZM18.7569 4.92878V17.9002H5.24265V4.92878C5.24265 4.15601 5.86988 3.52878 6.64265 3.52878H17.3569C18.1297 3.52878 18.7569 4.15601 18.7569 4.92878Z" />
            </svg>
        ),
    },
];

export const formatCurrency = (amount, currency = 'USD') => {    
    amount = amount?.toString()?.replace(/,/g,'');
    return Number(amount).toLocaleString('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
